export const FILTER_ATTRIBUTE_KEYS = {
  BRAND: 'brand',
  CHARACTERISTICS: 'characteristics',
  REBUY_GUARANTEE_OPTION: 'int_rbg',
};
export const MINIMUM_QUANTITY_ATTRIBUTE: string = 'mpq';
